<section id="answerSection" aria-labelledby="answers-section-title" class="pb-10 md:pb-36 relative">
  <!-- Фон -->
  <div class="absolute inset-0 bg-[#f3f7f8] rounded-tl-[70px] rounded-tr-[70px]"></div>

  <div class="custom-container relative z-10 pt-10">
    <!-- Заголовок и кнопки -->
    <div class="flex flex-row items-center justify-center md:justify-between relative">
      <!-- Левый заголовок -->
      <div class="text-[#121212] font-medium text-[28px] sm:text-[28px] md:text-[70px] leading-[120%]  
         text-center md:text-left md:max-w-[330px]" data-animate="title"
        [innerHTML]="'home.home_calculator_title' | translate | safeHtml">
      </div>

      <!-- Правая колонка: текст сверху, кнопки снизу -->
      <div class="hidden md:block">
        <div class="flex flex-col justify-between items-start gap-4 w-[450px]" data-animate="rightCol">
          <!-- Текст -->
          <div
            class="text-[rgba(18,18,18,0.50)] text-left font-['-',_sans-serif] text-sm font-normal relative self-stretch">
            <span>
              <span class="trc-20-2-5-span" [innerHTML]="'home.home_calculator_desc_1' | translate | safeHtml">
              </span>
              <span class="trc-20-2-5-span2 font-semibold"
                [innerHTML]="'home.home_calculator_desc_2' | translate | safeHtml"></span>
            </span>
          </div>

          <!-- Кнопки -->
          <div class="flex gap-4">
            <button (click)="setAction('BUY')" [ngClass]="{
              'bg-[#2b75db] text-white': actionType() === 'BUY',
              'bg-[rgba(18,18,18,0.10)] border-solid border-[rgba(18,18,18,0.10)] text-black': actionType() !== 'BUY'
            }"
              class="font-bold rounded-full px-6 h-14 flex-1 flex items-center justify-center gap-2 transition-colors whitespace-nowrap">
              {{ 'buy_usdt' | translate }}
              <img [src]="actionType() === 'BUY'
              ? '/images/icons/arrows/right-up-white.svg'
              : '/images/icons/arrows/right-up-black.svg'" alt="arrow icon" class="w-6 h-3" />
            </button>

            <button (click)="setAction('SELL')" [ngClass]="{
              'bg-[#2b75db] text-white': actionType() === 'SELL',
              'bg-[rgba(18,18,18,0.10)] border-solid border-[rgba(18,18,18,0.10)] text-black': actionType() !== 'SELL'
            }"
              class="font-bold rounded-full px-6 h-14 flex-1 flex items-center justify-center gap-2 transition-colors whitespace-nowrap">
              {{ 'sell_usdt' | translate }}
              <img [src]="actionType() === 'SELL'
              ? '/images/icons/arrows/down-left-white.svg'
              : '/images/icons/arrows/down-left-black.svg'" alt="arrow icon" class="w-6 h-3" />
            </button>
          </div>
        </div>

      </div>
    </div>


    <!-- Форма -->
    <div class="flex flex-col md:flex-row gap-6 mt-16">
      <!-- Левая колонка -->
      <div class="flex flex-col gap-4 md:w-[300px] w-full" data-animate="leftCol">
        <div class="bg-white rounded-3xl p-8 flex flex-col gap-6">
          <div class="flex items-center justify-between">
            <div class="flex items-center">
              <img src="/images/icons/currency/usdt.svg" class="w-10 h-10" />

              <div class="relative -ml-3 w-12 h-12 flex items-center justify-center">
                <!-- белый круг — абсолют и центрирование -->
                <div class="absolute inset-0 flex items-center justify-center">
                  <div class="w-12 h-12 bg-white rounded-full z-0"></div>
                </div>

                <!-- флаг сверху -->
                <img src="/images/icons/currency/uzb-flag.svg" class="relative w-10 h-10 z-10" />
              </div>
            </div>
            <div class="text-[rgba(18,18,18,0.50)] text-base font-medium">1 USDT → UZS</div>
          </div>
          <div class="flex items-end gap-2">
            <div class="text-[#121212] text-2xl font-bold">{{placeholderRate()}}</div>
            <div class="text-[rgba(18,18,18,0.50)] font-semibold">UZS</div>
          </div>
        </div>

        <div class="bg-[rgba(43,117,219,0.05)] rounded-3xl p-4 text-[#2b75db] font-medium text-base"
          data-animate="info1">
          {{ 'fee.calc_commission_description' | translate }}
        </div>
        <div class="bg-[rgba(23,163,74,0.05)] rounded-3xl p-4 text-[#17a34a] font-medium text-base"
          data-animate="info2">
          {{ 'transfer_fast' | translate }}
        </div>
      </div>

      <!-- Правая колонка -->
      <div class="flex flex-col gap-4 md:flex-1" data-animate="rightForm">
        <!-- Ввод USDT -->
        <div class="bg-white rounded-[36px] p-8 flex flex-wrap gap-4">
          <!-- Input USDT -->
          <div class="flex items-center gap-2 border border-[rgba(18,18,18,0.10)] rounded-full px-4 h-14">
            <img src="/images/icons/currency/usdt.svg" class="w-9 h-9" />
            <span class="font-bold text-[#121212]">USDT</span>
            <img src="/images/icons/arrows/down.svg" alt="arrow icon" class="ml-auto w-4 h-3" />
          </div>
          <div class="w-full justify-between break-after-auto">
            <div class="relative w-full">
              <input #inputEl type="text" class="input-custom-caret font-bold text-[50px]" mask="separator.2"
                [formControl]="amount" placeholder="1">
              <div #caretEl class="custom-caret"></div>
            </div>
          </div>
        </div>

        <!-- Output UZS -->
        <div class="bg-white rounded-[36px] p-8 flex flex-wrap gap-4">
          <div class="flex items-center gap-2 border border-[rgba(18,18,18,0.10)] rounded-full px-4 h-14">
            <img src="/images/icons/currency/uzb-flag.svg" class="w-9 h-9" />
            <span class="font-bold text-[#121212]">UZS</span>
            <img src="/images/icons/arrows/down.svg" alt="arrow icon" class="ml-auto w-4 h-3" />
          </div>
          <div class="w-full justify-between break-after-auto">
            <div class="relative w-full">
              <input type="text" class="font-bold text-[50px] w-full min-w-0
                border-0 outline-none focus:outline-none
                focus:ring-0 focus:border-0" mask="separator.2" [placeholder]="placeholderRate()" readonly
                [formControl]="result">
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="md:hidden">
      <div class="mt-4 flex flex-col justify-between items-center gap-4 w-full" data-animate="rightCol">
        <div class="flex gap-4">
          <button (click)="setAction('BUY')" [ngClass]="{
              'bg-[#2b75db] text-white': actionType() === 'BUY',
              'bg-[rgba(18,18,18,0.10)] border-solid border-[rgba(18,18,18,0.10)] text-black': actionType() !== 'BUY'
            }"
            class="font-bold rounded-full px-6 h-14 flex-1 flex items-center justify-center gap-2 transition-colors whitespace-nowrap">
            {{ 'buy_usdt' | translate }}
            <img [src]="actionType() === 'BUY'
              ? '/images/icons/arrows/right-up-white.svg'
              : '/images/icons/arrows/right-up-black.svg'" alt="arrow icon" class="w-6 h-3" />
          </button>

          <button (click)="setAction('SELL')" [ngClass]="{
              'bg-[#2b75db] text-white': actionType() === 'SELL',
              'bg-[rgba(18,18,18,0.10)] border-solid border-[rgba(18,18,18,0.10)] text-black': actionType() !== 'SELL'
            }"
            class="font-bold rounded-full px-6 h-14 flex-1 flex items-center justify-center gap-2 transition-colors whitespace-nowrap">
            {{ 'sell_usdt' | translate }}
            <img [src]="actionType() === 'SELL'
              ? '/images/icons/arrows/down-left-white.svg'
              : '/images/icons/arrows/down-left-black.svg'" alt="arrow icon" class="w-6 h-3" />
          </button>
        </div>
      </div>

    </div>
  </div>
</section>